function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSurfaceWater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M250.504 164.377 12.374 313.208c-6.499 4.062-6.499 13.526 0 17.588l238.13 148.831a10.368 10.368 0 0 0 10.992 0l238.13-148.831c6.499-4.062 6.499-13.526 0-17.588l-238.13-148.831a10.368 10.368 0 0 0-10.992 0z",
    style: {},
    fill: "#ffe177",
    "data-original": "#ffe177"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m499.626 313.208-15.53-9.706-230.6 144.125a10.368 10.368 0 0 1-10.992 0l-222.6-139.125-7.53 4.706c-6.499 4.062-6.499 13.526 0 17.588l238.13 148.831a10.368 10.368 0 0 0 10.992 0l238.13-148.831c6.499-4.062 6.499-13.526 0-17.588z",
    style: {},
    fill: "#ffd15b",
    "data-original": "#ffd15b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.715 156.988c0 41.816-33.899 75.715-75.715 75.715s-75.715-33.899-75.715-75.715c0-28.881 27.511-78.064 50.476-105.728C241.046 38.87 250.419 30.797 256 30.797c5.581 0 14.954 8.073 25.239 20.463 22.964 27.664 50.476 76.847 50.476 105.728z",
    style: {},
    fill: "#62dbfb",
    "data-original": "#62dbfb",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.239 51.26c-6.664-8.028-12.945-14.243-18.06-17.625 22.544 28.029 48.536 75.281 48.536 103.353 0 41.816-33.899 75.715-75.715 75.715-15.797 0-30.465-4.838-42.601-13.113 13.63 19.989 36.583 33.113 62.601 33.113 41.816 0 75.715-33.899 75.715-75.715 0-28.881-27.512-78.064-50.476-105.728z",
    style: {},
    fill: "#01d0fb",
    "data-original": "#01d0fb",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.461 79.332c0 16.083-13.038 29.121-29.121 29.121s-29.121-13.038-29.121-29.121c0-11.108 10.581-30.025 19.414-40.665 3.956-4.765 7.561-7.87 9.707-7.87 2.146 0 5.751 3.105 9.707 7.87 8.833 10.64 19.414 29.557 19.414 40.665z",
    style: {},
    fill: "#62dbfb",
    "data-original": "#62dbfb",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.047 38.667c-3.956-4.765-7.561-7.87-9.707-7.87-.443 0-.949.133-1.508.385 5.831 9.65 10.629 20.67 10.629 28.15 0 16.083-13.038 29.121-29.121 29.121-2.777 0-5.463-.389-8.006-1.115 3.478 12.19 14.7 21.115 28.006 21.115 16.083 0 29.121-13.038 29.121-29.121 0-11.108-10.581-30.025-19.414-40.665zM395.781 100.687c0 12.867-10.43 23.297-23.297 23.297s-23.297-10.43-23.297-23.297c0-8.887 8.465-24.02 15.531-32.532 3.165-3.812 6.049-6.296 7.766-6.296 1.717 0 4.601 2.484 7.766 6.296 7.066 8.513 15.531 23.646 15.531 32.532z",
    style: {},
    fill: "#01d0fb",
    "data-original": "#01d0fb",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m451.736 162.813 30.797 4.054-4.055 30.797M204.292 89.963c8.3-14.483 17.715-28.157 26.469-38.702C241.046 38.87 250.419 30.797 256 30.797c0 0 0 0 0 0 5.581 0 14.954 8.073 25.239 20.463 22.964 27.664 50.476 76.847 50.476 105.728 0 41.816-33.899 75.715-75.715 75.715s-75.715-33.899-75.715-75.715c0-9.894 3.228-22.17 8.397-35.147M174.461 79.332c0 16.083-13.038 29.121-29.121 29.121s-29.121-13.038-29.121-29.121c0-11.108 10.581-30.025 19.414-40.665 3.956-4.765 7.561-7.87 9.707-7.87h0c2.146 0 5.751 3.105 9.707 7.87 8.833 10.64 19.414 29.557 19.414 40.665zM395.781 100.687c0 12.867-10.43 23.297-23.297 23.297s-23.297-10.43-23.297-23.297c0-8.887 8.465-24.02 15.531-32.532 3.165-3.812 6.049-6.296 7.766-6.296h0c1.717 0 4.601 2.484 7.766 6.296 7.066 8.513 15.531 23.646 15.531 32.532zM415.881 260.868l-96.737-60.461M157.195 421.309l93.309 58.318a10.368 10.368 0 0 0 10.992 0l238.13-148.831c6.499-4.062 6.499-13.526 0-17.588l-53.561-33.475",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.835 200.42 12.374 313.208c-6.499 4.062-6.499 13.526 0 17.588l114.882 71.801",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.467 166.867 205.226 157.476c12.568 9.643 30.046 9.643 42.613 0l203.466-156.125M256 364.719v15.531M287.062 355.621l10.983 10.982M224.937 355.621l-10.982 10.982",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    className: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurfaceWater);
export default __webpack_public_path__ + "static/media/surfaceWater.595117ece58ff0e71262e15b0d632753.svg";
export { ForwardRef as ReactComponent };